import ObservacionesPreviaslist from './views/ObservacionesPreviasListView.vue'

export default [
  {
    path: '/antecedentes-observaciones',
    name: 'observacionesPrevias',
    props: true,
    component: ObservacionesPreviaslist
  }
]
